import {
    Formik,
    FormikProps
} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {
    Account,
    AccountFormType,
    AccountRecordFormProps,
    AccountStatus,
    AccountType
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: AccountRecordFormProps) => {

    const onSubmit = (values: AccountFormType) => {
        handleSubmit(values as Account);
    };

    let initialValues = {
        accountType: AccountType.STANDALONE,
        accountStatus: AccountStatus.ACTIVE,
    } as Account;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik<AccountFormType>
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<AccountFormType>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
